const locale: Locale = {
  ko: {
    principle: '지스트 청원 운영 원칙',
    content1_1:
      "타인의 권리를 침해하거나 명예를 훼손하는 내용은 제한합니다. \
      방송통신심의위원회의 '정보통신에 관한 심의 규정'‚ 한국인터넷자율정책기구의 \
      '정책규정'을 기반하여 문제되는 게시물은 삭제될 수 있습니다. \
      자극적이고 혐오스러운 내용‚ 비속어‚ 폭력적 내용‚ 특정 대상을 비하하거나 차별을 조장하는 내용‚ \
      개인정보 유출을 비롯해 타인의 권리를 침해하는 내용‚ 반복되는 내용‚ 허위사실 등은 ",
    content1_2: '삭제나 숨김',
    content1_3: ' 처리될 수 있습니다.',

    content2:
      '사전동의 5개 이상을 받고 운영측이 승인한 청원은 지스트청원 게시판에 공개됩니다. \
      청원을 작성한 날로부터 30일 안에 50명의 동의를 받은 청원에 대해‚ GIST대학 내 관련 부서에 청원을 보내 답변을 받아 게시합니다.',

    content3_1: '한 번 작성된 청원은 ',
    content3_2: '수정 및 삭제가 불가능',
    content3_3:
      '합니다. 청원의 본래 취지와 다른 내용으로 변경되는 것을 방지하여 \
      청원 참여자들의 의견을 보호하기 위한 방안이니 신중하게 작성하여 주시기 바랍니다.',

    content4_1:
      '유사한 내용으로 중복 게시된 청원들은 가장 동의수가 많은 청원만 남기고 모두 ',
    content4_2: '반려',
    content4_3: '될 수 있습니다.',
  },
  en: {
    principle: 'Principle of GIST Petition',
    content1_1:
      "Restricts content that infringes on or defames the rights of others. \
      Posts in question could be deleted based on the \
      'Deliberation Regulation on Information and Communication' of the Korea Communications Standards Commission \
      and the 'Regulatory Policy' of the Korea Internet Self-Governance Organization. \
      Stimulating, hateful and violent content, swear word, content that promotes discrimination \
      or demeans against somebody, infringes on other people's rights, \
      including personal information leakage, repeated content, misinformation, etc. ",
    content1_2: 'can be deleted or hidden',
    content1_3: '. ',

    content2:
      'The petition approved by the administrator after receiving more than 5 prior consent will be released on the petition list. \
      Within 30 days from the date of writing the petition, \
      a petition with more than 50 agreements will be sent to the relevant department of GIST College and posted with answer.',

    content3_1: 'Once a petition has been made, ',
    content3_2: 'it cannot be modified or deleted',
    content3_3:
      '. It is a measure to protect the opinions of the petition supporters \
      by preventing changes to the original purpose of the petition, so please write it carefully.',

    content4_1:
      'All petitions that have been repeatedly posted with similar content ',
    content4_2: 'could be rejected',
    content4_3: ', except the petition with the highest number of agreements.',
  },
}

export default locale
